export const isMainJs = process.env.REACT_APP_IS_MAIN_DASHBOARD
export const isTestingEnv = process.env.NODE_ENV === "test"
export const isDevelopmentEnv = process.env.NODE_ENV === "development"
